
import { Options, Vue } from 'vue-class-component'
import Ball from '@/utils/ball'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

import HongBao from '@/components/HongBao.vue'

@Options({
    data () {
        return {
            currentIndex: 0,
            textBall: null,
            btnShow: true,
            timeId1: null,
            timeId2: null
        }
    },
    components: {
        HongBao
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'yearData', 'activityData'])
    },
    beforeUnmount () {
        clearTimeout(this.timeId1)
        clearTimeout(this.timeId2)
        this.currentIndex = 0
        this.changeData(0)
    },
    mounted () {
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_HBDATA']),
        changeData (index?: number | string): void {
            if (!this.yearData) {
                return
            }
            const items = document.querySelectorAll('.page-footprint-item') as NodeListOf<HTMLElement>
            if (index !== 0) {
                this.currentIndex++
            }
            if (this.currentIndex === items.length) {
                const showDom = document.querySelector('.page-footprint-05 .main-item') as HTMLElement
                const hideDom = document.querySelector('.page-footprint-05 .main-item.hide') as HTMLElement
                showDom.className = 'main-item hide'
                hideDom.className = 'main-item'
                this.textBall && this.textBall.destroy()
                this.btnShow = false
                this.timeId1 = setTimeout(() => {
                    const hideDom = document.querySelectorAll('.page-footprint-05 .main-item')[1] as HTMLElement
                    hideDom.className = 'main-item leave'
                    this.timeId2 = setTimeout(() => {
                        this.SET_HBDATA(true)
                    }, 3000)
                }, 3000)
                return
            }
            items.forEach((node: HTMLElement, idx: number) => {
                let classNameArr: Array<string> = node.className.split(' ')
                let showIndex: number = classNameArr.indexOf('show')
                let hideIndex: number = classNameArr.indexOf('hide')
                showIndex > -1 && classNameArr.splice(showIndex, 1)
                hideIndex > -1 && classNameArr.splice(hideIndex, 1)
                let className:string = classNameArr.join(' ')
                if (this.currentIndex === idx) {
                    node.className = `${className} show`
                    if (this.currentIndex === items.length - 1 && this.yearData.channel_label) {
                        this.textBall = new Ball({
                            wrapper: '.page-footprint .tags'
                        })
                    }
                } else if (this.currentIndex - 1 === idx) {
                    node.className = `${className} hide`
                } else {
                    node.className = className
                }
            })
        }
    }
})
export default class FootPrint extends Vue {}
